/**
 * Modul Checkout Steps > Prices
 */

import {
	needJquery, extend
} from '../../../../shared/utils/index';


import SelectorEngine from '../../../../shared/dom/selector-engine';
import Manipulator from "../../../../shared/dom/manipulator";
import EventHandler from "../../../../shared/dom/event-handler";

import {validateCheckoutButton} from '../index';

// ------
// Private
// ------

const CHECKOUT_NAME      = 'prices';
const CHECKOUT_CONTAINER = SelectorEngine.findOne(`[data-checkout="${CHECKOUT_NAME}"]`);
const CHECKOUT_BUTTONS   = SelectorEngine.find(`[data-user-validation="${CHECKOUT_NAME}"]`);

const initValidation = (fields) => {
	let selectArray = Array.from(fields);

	if(CHECKOUT_BUTTONS.length) {
		for(const ELEMENT of CHECKOUT_BUTTONS) {
			validateCheckoutButton(ELEMENT, selectArray.every(select => select.value !== ''));
		}
	}
};

// ------
// Public
// ------

const init = () => {
	if(!CHECKOUT_CONTAINER) {
		return;
	}

	const SELECT_FIELDS = SelectorEngine.find(`select[data-${CHECKOUT_NAME}]`, CHECKOUT_CONTAINER);

	if(!SELECT_FIELDS.length) {
		return;
	}

	initValidation(SELECT_FIELDS);

	for(let selectField of SELECT_FIELDS) {
		EventHandler.on(selectField, 'change', () => {
			let selectArray = Array.from(SELECT_FIELDS);

			initValidation(SELECT_FIELDS);
		});
	}
};

// ------
// Export
// ------

export default {
	init : init
};